/*!
 * Rede i-tal — Catalog Cart Injector
 *
 * Injeta automaticamente `properties[_catalog]` em todo add ao carrinho,
 * com valor "A" ou "B" lido de localStorage/cookie/URL.
 *
 * Fontes (em ordem de prioridade):
 *   1. ?catalog=A na URL atual (override)
 *   2. localStorage['rdt_catalog']
 *   3. cookie rdt_catalog
 *   4. URL contém /entrega-agendada (ou /catalogo-a legacy) → A
 *   5. URL contém /entrega-expressa (ou /catalogo-b legacy) → B
 *   6. fallback: B
 *
 * Cobre 3 cenários de add ao carrinho:
 *   - Form submit clássico (Vegist usa /cart/add em form)
 *   - Fetch/XHR pra /cart/add.js (AJAX cart)
 *   - Função window.Shopify.theme.addItem (alguns temas)
 *
 * Carrega via <script src="{{ 'rdt-catalog.js' | asset_url }}" defer></script> no theme.liquid.
 */
(function(){
  'use strict';

  var COOKIE_NAME = 'rdt_catalog';
  var STORAGE_KEY = 'rdt_catalog';
  var PROP_KEY = '_catalog';

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(^|; )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  function getCatalog() {
    try {
      var url = new URL(window.location.href);
      var qp = (url.searchParams.get('catalog') || '').toUpperCase();
      if (qp === 'A' || qp === 'B') {
        persist(qp);
        return qp;
      }

      // URL da landing de modo TEM PRECEDÊNCIA sobre o storage: entrar em
      // /entrega-expressa é uma escolha explícita e sobrescreve o modo salvo.
      var path = window.location.pathname.toLowerCase();
      if (path.indexOf('/entrega-agendada') !== -1 || path.indexOf('/catalogo-a') !== -1) { persist('A'); return 'A'; }
      if (path.indexOf('/entrega-expressa') !== -1 || path.indexOf('/catalogo-b') !== -1) { persist('B'); return 'B'; }

      var ls = (localStorage.getItem(STORAGE_KEY) || '').toUpperCase();
      if (ls === 'A' || ls === 'B') return ls;

      var ck = (readCookie(COOKIE_NAME) || '').toUpperCase();
      if (ck === 'A' || ck === 'B') return ck;
    } catch(e) {}
    return 'A';   // default = Agendada (sempre disponível; Expressa tem janelas de horário)
  }

  function persist(cat) {
    try {
      localStorage.setItem(STORAGE_KEY, cat);
      document.cookie = COOKIE_NAME + '=' + cat + '; path=/; max-age=86400; samesite=lax';
    } catch(e) {}
  }

  // --- 0. Filtra navegação de categorias pelo catálogo atual ---
  // Quando o cliente clicou em "Entrega Agendada" ou "Entrega Expressa" na home,
  // qualquer link pra /collections/<categoria> (Frutas, Verduras, etc) recebe
  // ?filter.p.tag=agendada (ou expressa) pra mostrar só os produtos válidos.
  // Não toca em links pras próprias collections entrega-agendada / entrega-expressa.
  // Pula filtro apenas nas próprias coleções dos catálogos — todas as outras
  // (incluindo /collections/all e promoções) recebem o filtro do catálogo atual.
  var SKIP_HANDLES = ['entrega-agendada', 'entrega-expressa'];

  function tagForCatalog(cat) {
    return cat === 'A' ? 'agendada' : (cat === 'B' ? 'expressa' : null);
  }

  function shouldRewriteHref(href) {
    if (!href) return false;
    // só interno
    if (href.indexOf('http') === 0) {
      try { var u = new URL(href); if (u.hostname !== window.location.hostname) return false; } catch(e){ return false; }
    }
    if (href.indexOf('/collections/') === -1) return false;
    if (href.indexOf('filter.p.tag=') !== -1) return false;
    for (var i = 0; i < SKIP_HANDLES.length; i++) {
      if (href.indexOf('/collections/' + SKIP_HANDLES[i]) !== -1) return false;
    }
    return true;
  }

  function rewriteHref(href, tag) {
    try {
      var url = new URL(href, window.location.origin);
      url.searchParams.set('filter.p.tag', tag);
      return url.toString();
    } catch(e) {
      return href + (href.indexOf('?') > -1 ? '&' : '?') + 'filter.p.tag=' + tag;
    }
  }

  // Mapa de handle → catálogos permitidos (carregado do Worker em background)
  var _categoryCatalogs = null;
  function loadCategoryCatalogs() {
    fetch('https://rdt-shipping.redeital.workers.dev/admin/api/categories-public', { credentials: 'omit' })
      .then(function(r){ return r.json(); })
      .then(function(d){
        _categoryCatalogs = {};
        (d.categories || []).forEach(function(c){
          _categoryCatalogs[c.handle] = { A: c.agendada, B: c.expressa };
        });
        hideExcludedCategoryLinks();
      })
      .catch(function(){});
  }

  function handleFromHref(href) {
    var m = String(href).match(/\/collections\/([a-z0-9\-_]+)/i);
    return m ? m[1].toLowerCase() : null;
  }

  function hideExcludedCategoryLinks() {
    if (!_categoryCatalogs) return;
    var cat = getCatalog();
    if (cat !== 'A' && cat !== 'B') return;
    var anchors = document.querySelectorAll('a[href*="/collections/"]');
    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i];
      var h = handleFromHref(a.getAttribute('href'));
      if (!h) continue;
      var perm = _categoryCatalogs[h];
      if (!perm) continue;  // categoria não tracked (default = visível)
      if (!perm[cat]) {
        // Esconde o item de menu pai (li, ou container)
        var hideTarget = a.closest('li') || a.closest('.rdt-cat-section') || a.closest('.rdt-cat-card-wrap') || a;
        hideTarget.style.display = 'none';
      }
    }
  }

  function patchAllCategoryLinks() {
    var cat = getCatalog();
    var tag = tagForCatalog(cat);
    if (!tag) return;
    var anchors = document.querySelectorAll('a[href*="/collections/"]');
    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i];
      if (a.dataset.rdtPatched === '1') continue;
      if (!shouldRewriteHref(a.getAttribute('href'))) continue;
      a.href = rewriteHref(a.href, tag);
      a.dataset.rdtPatched = '1';
    }
    hideExcludedCategoryLinks();
  }

  function maybePatchClick(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="/collections/"]') : null;
    if (!a) return;
    if (a.dataset.rdtPatched === '1') return;
    var cat = getCatalog();
    var tag = tagForCatalog(cat);
    if (!tag) return;
    if (!shouldRewriteHref(a.getAttribute('href'))) return;
    a.href = rewriteHref(a.href, tag);
    a.dataset.rdtPatched = '1';
  }

  // Auto-redirect quando usuário entra direto numa /collections/<X> sem filtro
  // (ex: /collections/all, /collections/promocoes, ou compartilhamento de link sem param).
  // Pula as próprias coleções dos catálogos e qualquer URL que JÁ tem filtro.
  function maybeRedirectToFiltered() {
    try {
      var path = window.location.pathname.toLowerCase();
      if (path.indexOf('/collections/') !== 0) return;
      var handle = path.replace(/^\/collections\//, '').split('/')[0];
      if (!handle) return;
      for (var i = 0; i < SKIP_HANDLES.length; i++) {
        if (handle === SKIP_HANDLES[i]) return;
      }
      var url = new URL(window.location.href);
      if (url.searchParams.has('filter.p.tag')) return;  // já filtrado
      var cat = getCatalog();
      var tag = tagForCatalog(cat);
      if (!tag) return;
      url.searchParams.set('filter.p.tag', tag);
      window.location.replace(url.toString());
    } catch(e) {}
  }
  maybeRedirectToFiltered();

  loadCategoryCatalogs();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchAllCategoryLinks);
  } else {
    patchAllCategoryLinks();
  }
  // Cobre links que aparecem depois (lazy load, ajax)
  document.addEventListener('click', maybePatchClick, true);
  document.addEventListener('mouseover', maybePatchClick, true);
  // E re-patch periódico pra DOM dinâmico (sidebar de categoria expansível, etc)
  setInterval(patchAllCategoryLinks, 2000);

  // --- 0.4 Oculta no grid os produtos que não são do modo escolhido ---
  // O filtro nativo do Shopify (?filter.p.tag) está desativado nesta loja, então
  // filtramos client-side de forma determinística: cada card traz data-rdt-modes
  // (renderizado pelo Liquid) e escondemos a célula inteira quando o modo atual
  // não está na lista. Funciona em categoria, /all, busca e produtos relacionados.
  function filterGridByMode() {
    // Não mexe em coleções que JÁ são filtradas no servidor por modalidade
    // (entrega-agendada/expressa e as coleções <categoria>-agendada/-expressa).
    var pth = location.pathname.toLowerCase();
    if (pth.indexOf('/collections/') === 0) {
      var hcur = pth.replace('/collections/', '').split('/')[0];
      if (/-(agendada|expressa)$/.test(hcur) || hcur === 'entrega-agendada' || hcur === 'entrega-expressa') return;
    }
    var cat = getCatalog();
    var tag = tagForCatalog(cat);     // 'agendada' | 'expressa'
    if (!tag) return;
    var cards = document.querySelectorAll('.single-product-wrap[data-rdt-modes]');
    for (var i = 0; i < cards.length; i++) {
      var modes = (cards[i].getAttribute('data-rdt-modes') || '').trim();
      var cell = cards[i].closest('li.st-col-item') || cards[i].closest('li') || cards[i];
      if (!modes) { cell.style.display = ''; continue; } // sem modo → sempre visível
      cell.style.display = (modes.indexOf(tag) !== -1) ? '' : 'none';
    }
  }
  // roda cedo, em mudanças de DOM (paginação ajax/lazyload) e periodicamente
  if (document.readyState !== 'loading') filterGridByMode();
  document.addEventListener('DOMContentLoaded', filterGridByMode);
  try {
    var _grid = document.getElementById('product-grid') || document.body;
    if (window.MutationObserver && _grid) {
      var _deb;
      new MutationObserver(function(){ clearTimeout(_deb); _deb = setTimeout(filterGridByMode, 80); })
        .observe(_grid, { childList: true, subtree: true });
    }
  } catch(e) {}
  setInterval(filterGridByMode, 1500);

  // --- 0.45 Barra de frete grátis só na Agendada (Expressa não tem frete grátis) ---
  try {
    var _fsStyle = document.createElement('style');
    _fsStyle.textContent = '.rdt-mode-b .shipping-bar{display:none !important}';
    (document.head || document.documentElement).appendChild(_fsStyle);
  } catch(e) {}
  function applyModeClass() {
    var b = getCatalog() === 'B';
    var r = document.documentElement;
    r.classList.toggle('rdt-mode-b', b);
    r.classList.toggle('rdt-mode-a', !b);
  }
  if (document.readyState !== 'loading') applyModeClass();
  document.addEventListener('DOMContentLoaded', applyModeClass);
  setInterval(applyModeClass, 1500);

  // --- 0.47 Bloqueio de mistura de modalidade no carrinho ---
  // Não toca no fluxo de add (zero risco). Detecta quando o carrinho tem itens de
  // um modo e o cliente entrou no outro, e oferece esvaziar ou voltar.
  var _cartConflictChecked = false;
  function modeLabelFull(m){ return m === 'A' ? 'Entrega Agendada' : 'Entrega Hoje (Expressa)'; }
  function checkCartModeConflict() {
    if (_cartConflictChecked) return;
    _cartConflictChecked = true;
    try {
      var cur = getCatalog();
      if (cur !== 'A' && cur !== 'B') return;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r){ return r.json(); })
        .then(function(cart){
          if (!cart || !cart.items || !cart.items.length) return;
          var hasA = false, hasB = false;
          cart.items.forEach(function(it){
            var c = it.properties && it.properties._catalog;
            if (c === 'A') hasA = true; else if (c === 'B') hasB = true;
          });
          var cartMode = (hasA && !hasB) ? 'A' : ((hasB && !hasA) ? 'B' : null);
          if (!cartMode || cartMode === cur) return;   // sem conflito
          var ok = window.confirm(
            'Seu carrinho tem itens de ' + modeLabelFull(cartMode) + ', mas você está em ' +
            modeLabelFull(cur) + '.\n\nCada modalidade tem regras de entrega diferentes — não dá pra misturar no mesmo pedido.\n\n' +
            'OK = esvaziar o carrinho e seguir em ' + modeLabelFull(cur) + '.\n' +
            'Cancelar = voltar para ' + modeLabelFull(cartMode) + '.'
          );
          if (ok) {
            fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' });
          } else {
            persist(cartMode);
            window.location.href = '/collections/entrega-' + (cartMode === 'A' ? 'agendada' : 'expressa');
          }
        })
        .catch(function(){});
    } catch(e) {}
  }
  if (document.readyState !== 'loading') checkCartModeConflict();
  else document.addEventListener('DOMContentLoaded', checkCartModeConflict);

  // --- 0.48 Não abrir o drawer sozinho a cada add; mostrar mini-confirmação ---
  // Suprime a abertura automática SÓ na janela logo após um add (clique manual no
  // ícone do carrinho continua abrindo normal). Mostra um toast "Ver carrinho".
  var _suppressOpenUntil = 0;
  window.__rdtMarkAdd = function(){ _suppressOpenUntil = Date.now() + 4000; };
  function _closeDrawer(){
    var d = document.querySelector('.mini-cart.active'); if (d) d.classList.remove('active');
    var o = document.querySelector('.ajax-cart-overlay.active'); if (o) o.classList.remove('active');
    document.documentElement.style.overflow = ''; document.body.style.overflow = '';
    document.body.classList.remove('cart-open','overflow-hidden','no-scroll','ajax-cart-open');
  }
  function _hideToast(){ var t = document.getElementById('rdt-cart-toast'); if (t) t.classList.remove('show'); }
  function _showToast(){
    var t = document.getElementById('rdt-cart-toast');
    if (!t){
      var st = document.createElement('style');
      st.textContent = '#rdt-cart-toast{position:fixed;right:18px;bottom:84px;z-index:9999;background:#2D5E1F;color:#fff;border-radius:10px;padding:12px 14px;box-shadow:0 8px 22px rgba(0,0,0,.25);display:flex;gap:12px;align-items:center;font-size:14px;opacity:0;transform:translateY(8px);transition:opacity .2s,transform .2s}#rdt-cart-toast.show{opacity:1;transform:none}#rdt-cart-toast .rdt-toast-cta{background:#fff;color:#2D5E1F;border:0;border-radius:7px;padding:6px 12px;font-weight:600;cursor:pointer;white-space:nowrap}@media(max-width:600px){#rdt-cart-toast{left:14px;right:14px;bottom:80px}}';
      document.head.appendChild(st);
      t = document.createElement('div'); t.id = 'rdt-cart-toast';
      t.innerHTML = '<span>✓ Adicionado ao carrinho</span><button type="button" class="rdt-toast-cta">Ver carrinho</button>';
      document.body.appendChild(t);
      t.querySelector('.rdt-toast-cta').addEventListener('click', function(){
        _suppressOpenUntil = 0;
        var d = document.querySelector('.mini-cart'); var o = document.querySelector('.ajax-cart-overlay');
        if (d) d.classList.add('active'); if (o) o.classList.add('active');
        _hideToast();
      });
    }
    t.classList.add('show');
    clearTimeout(t.__to); t.__to = setTimeout(_hideToast, 4500);
  }
  function _watchDrawer(){
    var drawer = document.querySelector('.mini-cart');
    if (!drawer || !window.MutationObserver) return;
    new MutationObserver(function(){
      if (Date.now() > _suppressOpenUntil) return;       // fora da janela pós-add → deixa abrir
      if (drawer.classList.contains('active')){ _closeDrawer(); _showToast(); _suppressOpenUntil = 0; }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState !== 'loading') _watchDrawer();
  else document.addEventListener('DOMContentLoaded', _watchDrawer);

  // --- 0.5 Trava de modo na página de produto ---
  // Impede adicionar ao carrinho um produto que não pertence ao modo selecionado
  // (ex: cliente em Entrega Agendada abrindo um produto só de Expressa). Sem isso,
  // o item entrava no carrinho com o modo errado e bagunçava o frete no checkout.
  function modeLabel(cat) { return cat === 'A' ? 'Entrega Agendada' : 'Entrega Hoje (Expressa)'; }
  function tagToCat(tag) { return tag === 'agendada' ? 'A' : (tag === 'expressa' ? 'B' : null); }

  function enforceProductMode() {
    var gateEl = document.querySelector('cart-action[data-rdt-modes]');
    if (!gateEl) return;  // não é página de produto com modos
    var modesAttr = (gateEl.getAttribute('data-rdt-modes') || '').trim().toLowerCase();
    var modes = modesAttr ? modesAttr.split(/\s+/) : [];
    var cat = getCatalog();
    var curTag = tagForCatalog(cat);  // agendada|expressa
    var box = gateEl.querySelector('.rdt-mode-gate');
    var btn = gateEl.querySelector('button[name="add"]');

    // Produto sem modo nenhum (ex: item que não é hortifruti A/B) → não trava
    if (modes.length === 0) return;
    // Produto disponível no modo atual → libera (garante estado limpo)
    if (modes.indexOf(curTag) !== -1) {
      if (box) { box.hidden = true; box.innerHTML = ''; }
      return;
    }
    // Produto NÃO disponível no modo atual → trava + oferece troca
    var outroTag = modes[0];                 // o modo que o produto suporta
    var outroCat = tagToCat(outroTag);
    if (box) {
      box.hidden = false;
      box.innerHTML = 'Este produto está disponível apenas em <strong>' + modeLabel(outroCat) +
        '</strong>. <a href="#" class="rdt-switch-mode" data-cat="' + outroCat +
        '" style="color:#92400e;text-decoration:underline;font-weight:600">Mudar para ' + modeLabel(outroCat) + '</a>';
      var link = box.querySelector('.rdt-switch-mode');
      if (link) link.addEventListener('click', function(e) {
        e.preventDefault();
        persist(this.getAttribute('data-cat'));
        window.location.reload();
      });
    }
    if (btn) {
      btn.disabled = true;
      var t = btn.querySelector('.cart-title');
      if (t) t.textContent = 'Indisponível neste modo';
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforceProductMode);
  } else {
    enforceProductMode();
  }

  // --- 1. Form submit clássico ---
  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    if (window.__rdtMarkAdd) window.__rdtMarkAdd();

    var cat = getCatalog();
    // Evita duplicar input se já injetado
    if (form.querySelector('input[name="properties[' + PROP_KEY + ']"]')) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[' + PROP_KEY + ']';
    input.value = cat;
    form.appendChild(input);
  }, true);

  // --- 2. Intercepta fetch pra /cart/add.js ---
  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function(input, init) {
      try {
        var url = typeof input === 'string' ? input : input.url;
        if (url && url.indexOf('/cart/add') !== -1) {
          if (window.__rdtMarkAdd) window.__rdtMarkAdd();
          if (init && init.body) init.body = injectCatalogInBody(init.body, getCatalog());
        }
      } catch(e) {}
      return originalFetch.call(this, input, init);
    };
  }

  // --- 3. Intercepta XHR (jQuery.ajax do Vegist usa XHR) ---
  var XHR = window.XMLHttpRequest;
  if (XHR) {
    var origOpen = XHR.prototype.open;
    var origSend = XHR.prototype.send;
    XHR.prototype.open = function(method, url) {
      this.__rdt_url = url;
      return origOpen.apply(this, arguments);
    };
    XHR.prototype.send = function(body) {
      try {
        if (this.__rdt_url && this.__rdt_url.indexOf('/cart/add') !== -1) {
          if (window.__rdtMarkAdd) window.__rdtMarkAdd();
          if (body) body = injectCatalogInBody(body, getCatalog());
        }
      } catch(e) {}
      return origSend.call(this, body);
    };
  }

  function injectCatalogInBody(body, cat) {
    // JSON body
    if (typeof body === 'string') {
      try {
        var parsed = JSON.parse(body);
        addToObj(parsed, cat);
        return JSON.stringify(parsed);
      } catch(e) {
        // URL-encoded form?
        if (body.indexOf('properties%5B' + PROP_KEY + '%5D') === -1 &&
            body.indexOf('properties[' + PROP_KEY + ']') === -1) {
          var sep = body.length > 0 ? '&' : '';
          return body + sep + 'properties%5B' + PROP_KEY + '%5D=' + cat;
        }
      }
    }
    // FormData
    else if (typeof FormData !== 'undefined' && body instanceof FormData) {
      if (!body.has('properties[' + PROP_KEY + ']')) {
        body.append('properties[' + PROP_KEY + ']', cat);
      }
    }
    // URLSearchParams
    else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      if (!body.has('properties[' + PROP_KEY + ']')) {
        body.append('properties[' + PROP_KEY + ']', cat);
      }
    }
    return body;
  }

  function addToObj(obj, cat) {
    if (!obj) return;
    // Formato { items: [{...}, ...] }
    if (Array.isArray(obj.items)) {
      obj.items.forEach(function(it){ ensureProps(it, cat); });
    } else {
      ensureProps(obj, cat);
    }
  }
  function ensureProps(it, cat) {
    if (!it) return;
    if (!it.properties || typeof it.properties !== 'object') it.properties = {};
    if (!(PROP_KEY in it.properties)) it.properties[PROP_KEY] = cat;
  }

  // Expõe pra debug
  window.__rdtCatalog = { get: getCatalog, set: persist };
})();
